import { useLocation } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';

const useNavigation = () => {
    const location = useLocation();
    const [path, setPath] = useState<string | null>(null);

    useEffect(() => {
        setPath(location.pathname);
    }, [location.pathname]);

    return useMemo(() => ({ path }), [path]);
};

export { useNavigation };
